import { XIcon } from '@heroicons/react/solid'
import styled from 'styled-components'

export const CloseIcon = styled(XIcon)`
  &:hover {
    cursor: pointer;
  }
`
